export default "__VITE_ASSET__f8a8e03a__"